import { all } from 'redux-saga/effects';
import { carriersSaga } from './carriers/carriers.saga';
import { resubmissionSaga } from './resubmission/resubmission.saga';

function* portSaga() {
    yield all([carriersSaga(), resubmissionSaga()]);
}

export { portSaga };
